// @flow

export const SET_SEARCH_PASSENGER = "set_search_passenger";
